export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5955.4a5c452b.jpg";